import { HttpClient } from './httpClient'
import { ApiVersion } from './types'

export type Props = {
  basePath: string
  apiVersion?: ApiVersion
}

export function ApiService(props: Props) {
  class BaseApiService {
    protected static readonly http = new HttpClient(props.basePath, props.apiVersion)
  }

  return BaseApiService
}
